import React, { useState } from 'react'
import "./dashboard.css";
// ... (Tus imports de iconos se mantienen igual) ...
import HamburgerIcon from '../assets/icons/hamburger';
import ListIcon from '../assets/icons/list';
import BellIcon from '../assets/icons/bell';
import TeamIcon from '../assets/icons/team';
import GearIcon from '../assets/icons/gear';
import SignOutIcon from '../assets/icons/sign-out';
import GnpLogo from '../assets/logos/logo.png';
import FilterIcon from '../assets/icons/filter';
import SearchIcon from '../assets/icons/search';
import GraphBarsIcon from '../assets/icons/graph-bars';
import AddSquareIcon from '../assets/icons/add-square';
import AddRequestIcon from '../assets/icons/add-request';
import { CodeBlock, monokai } from "react-code-blocks";
import { endpointData } from "../data/endpointData";
import Sandbox from './Sandbox/Sandbox';

// IMPORTAMOS EL NUEVO COMPONENTE
import OnboardingBoard from './form/OnboardingBoard';

function Dashboard() {

    // Solo mantenemos estados de NAVEGACIÓN
    const [activeTab, setActiveTab] = useState('list');
    const [activeEndpoint, setActiveEndpoint] = useState(-1);
    const [searchValue, setSearchValue] = useState("");
    const [showSandbox, setShowSandbox] = useState(false);

    const handleEndpointClick = (index) => {
        setActiveEndpoint(index);
        setShowSandbox(false);
    }

    return (
        <div className="dashboard_container">
            <div className="dashboard_top_bar">
                <div className="dashboard_logo">
                    <img src={GnpLogo} alt="Logo" />
                    <span>MASTERCARD - SCORCE</span>
                </div>
            </div>
            <div className="dashboard_main">
                <div className="navbar_menu">
                    {/* ... (Tus botones del navbar se mantienen igual) ... */}
                    <div className="navbar_button disabled"><HamburgerIcon /></div>
                    
                    <div className={`navbar_button ${activeTab === 'list' ? 'active' : ''}`} onClick={() => setActiveTab('list')}>
                        {activeTab === 'list' && <span className="navbar_button_active_block"></span>}
                        <ListIcon />
                    </div>

                    <div className={`navbar_button ${activeTab === 'notifications' ? 'active' : ''}`} onClick={() => setActiveTab('notifications')}>
                        {activeTab === 'notifications' && <span className="navbar_button_active_block"></span>}
                        <BellIcon />
                    </div>
                    {/* ... (Resto de botones navbar) ... */}
                    <div className="navbar_button disabled"><TeamIcon /></div>
                    <div className="navbar_button disabled"><GraphBarsIcon /></div>
                    <div className="navbar_button float_bottom disabled"><GearIcon /></div>
                    <div className="navbar_button disabled"><SignOutIcon /></div>
                </div>

                <div className="dashboard_body">
                    
                    {/* VISTA 1: LISTA (Sin cambios, solo oculto para resumir aquí) */}
                    {activeTab === 'list' && (
                        <>
                            <div className="dashboard_menu">
                                {/* ... (Todo el código del menú lateral de endpoints) ... */}
                                <div className="dashboard_menu_header">
                                    <div className="dashboard_menu_title"><h2>Endpoints List</h2>{/* ... */}</div>
                                    <div className="input_container input_container_prefix">
                                        <input type="text" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} placeholder="Search" />
                                        <div className="input_container_prefix_icon"><SearchIcon /></div>
                                    </div>
                                </div>
                                <div className="endpoint_list">
                                    {endpointData.filter(e => e.endpointName.toLowerCase().includes(searchValue.toLowerCase())).map((endpoint, index) => (
                                        <div key={index} className={"endpoint_item" + (index === activeEndpoint ? " active" : "")} onClick={() => handleEndpointClick(index)}>
                                            <div className="endpoint_item_wrapper">
                                                {index === activeEndpoint && <div className="endpoint_item_active_bar"></div>}
                                                <h2>{endpoint.endpointName}</h2>
                                                <p className="card_labels"><span>Categories:</span><div className="card_label_values">{endpoint.categories}</div></p>
                                                <p className="card_labels"><span>Countries:</span><div className="card_label_values">{endpoint.countries}</div></p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            {/* CONTENIDO DEL ENDPOINT SELECCIONADO */}
                            {activeEndpoint !== -1 && (
                                <div className="dashboard_content">
                                     {/* ... (Todo el código original de endpointData, Sandbox, CodeBlock, etc) ... */}
                                     {/* ... Resumido para no llenar la pantalla ... */}
                                    <div className="dashboard_content_header">
                                        <h1>{endpointData[activeEndpoint].endpointName}</h1>
                                        <div className={"btn " + (!showSandbox ? " btn_primary" : "")} onClick={() => setShowSandbox(!showSandbox)}>
                                            {!showSandbox ? <span>Send a request</span> : <span>Documentation</span>}
                                        </div>
                                    </div>
                                    <div className="dashboard_main_scroll">
                                        {!showSandbox ? 
                                            <div className="dashboard_main_wrapper">
                                                <p className="endpoint_description">{endpointData[activeEndpoint].description}</p>
                                                {/* ... Resto de tu UI de Endpoints ... */}
                                                <div className="flex_right_side">
                                                     {/* ... etc ... */}
                                                     <div className="api_code"><div className="api_code_background"><CodeBlock text={endpointData[activeEndpoint].response} language='typescript' showLineNumbers={true} theme={monokai}/></div></div>
                                                </div>
                                            </div> 
                                            : <Sandbox activeEndpoint={activeEndpoint} />
                                        }
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    {/* VISTA 2: FORMULARIO (Ahora es solo una línea) */}
                    {activeTab === 'notifications' && (
                        <OnboardingBoard />
                    )}

                </div>
            </div>
        </div>
    )
}

export default Dashboard